module.exports = __webpack_public_path__ + "files/1c46ba2a7596e23a827d5e87c47a019e.png";